import { render, staticRenderFns } from "./manage-admins.vue?vue&type=template&id=00e537a0"
import script from "./manage-admins.vue?vue&type=script&lang=js"
export * from "./manage-admins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports